import { render, staticRenderFns } from "./sales-invoices-layout.vue?vue&type=template&id=0f53f114"
import script from "./sales-invoices-layout.vue?vue&type=script&lang=js"
export * from "./sales-invoices-layout.vue?vue&type=script&lang=js"
import style0 from "./sales-invoices-layout.vue?vue&type=style&index=0&id=0f53f114&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports